// Airport code → city name. Used to rank location autocomplete results:
// when a user is building a job with airportCode "CLT", locations whose
// address contains "Charlotte" float to the top of the match list.
export const AIRPORT_CITIES = {
  CLT: "Charlotte",
  SDF: "Louisville",
  ATL: "Atlanta",
  MIA: "Miami",
  JFK: "New York",
  LGA: "New York",
  EWR: "Newark",
  LAX: "Los Angeles",
  ORD: "Chicago",
  DFW: "Dallas",
  IAH: "Houston",
  PHX: "Phoenix",
  SEA: "Seattle",
  SFO: "San Francisco",
  BOS: "Boston",
  PHL: "Philadelphia",
  DEN: "Denver",
  DCA: "Washington",
  IAD: "Washington",
  BWI: "Baltimore",
  LAS: "Las Vegas",
  MSP: "Minneapolis",
  DTW: "Detroit",
  RDU: "Raleigh",
  GSO: "Greensboro",
  ILM: "Wilmington",
  AVL: "Asheville",
};

export function cityForAirport(code) {
  if (!code) return "";
  return AIRPORT_CITIES[String(code).toUpperCase()] || "";
}

// Approximate cargo-terminal coordinates for major airports. Used as a
// fallback when an airport stop has no lat/lng stored (e.g. it was seeded
// from just the airport code). Close enough for mileage estimates.
export const AIRPORT_COORDS = {
  CLT: { lat: 35.2140, lng: -80.9431 },
  SDF: { lat: 38.1744, lng: -85.7364 },
  ATL: { lat: 33.6407, lng: -84.4277 },
  MIA: { lat: 25.7959, lng: -80.2870 },
  JFK: { lat: 40.6413, lng: -73.7781 },
  LGA: { lat: 40.7769, lng: -73.8740 },
  EWR: { lat: 40.6895, lng: -74.1745 },
  LAX: { lat: 33.9416, lng: -118.4085 },
  ORD: { lat: 41.9742, lng: -87.9073 },
  DFW: { lat: 32.8998, lng: -97.0403 },
  IAH: { lat: 29.9902, lng: -95.3368 },
  PHX: { lat: 33.4342, lng: -112.0116 },
  SEA: { lat: 47.4502, lng: -122.3088 },
  SFO: { lat: 37.6213, lng: -122.3790 },
  BOS: { lat: 42.3656, lng: -71.0096 },
  PHL: { lat: 39.8744, lng: -75.2424 },
  DEN: { lat: 39.8561, lng: -104.6737 },
  DCA: { lat: 38.8512, lng: -77.0402 },
  IAD: { lat: 38.9531, lng: -77.4565 },
  BWI: { lat: 39.1774, lng: -76.6684 },
  LAS: { lat: 36.0840, lng: -115.1537 },
  MSP: { lat: 44.8848, lng: -93.2223 },
  DTW: { lat: 42.2124, lng: -83.3534 },
  RDU: { lat: 35.8776, lng: -78.7875 },
  GSO: { lat: 36.0978, lng: -79.9373 },
  ILM: { lat: 34.2706, lng: -77.9026 },
  AVL: { lat: 35.4362, lng: -82.5418 },
};

export function coordsForAirport(code) {
  if (!code) return null;
  return AIRPORT_COORDS[String(code).toUpperCase()] || null;
}
